import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { getCostBreakdownV2WidgetDataByWidgetIdThunk } from "./getCostBreakdownV2WidgetDataByWidgetIdThunk";
import { DashboardWidgetCostBreakdownRequest } from "../../../../../services/cloudchipr.api";
import { currentDashboardIdSelector } from "../../../selectors/dashboard/currentDashboardIdSelector";
import { RootState } from "../../../../store";
import { buildWidgetThunk } from "../common/buildWidgetThunk";
import { costBreakdownV2WidgetSetupSelector } from "../../../selectors/setups/cost-breakdown-v2/costBreakdownV2WidgetSetupSelector";

export const buildCostBreakdownV2WidgetThunkThunk = createAsyncThunk(
  "dashboards/buildCostBreakdownWidget",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const dashboardId = currentDashboardIdSelector(state);
    const setup = costBreakdownV2WidgetSetupSelector(state);

    if (!dashboardId || !setup?.viewId) {
      return;
    }

    const widget: DashboardWidgetCostBreakdownRequest = {
      name: setup.name,
      view_id: setup.viewId,
      grouping: setup.grouping,
      group_values: setup.group_values ?? undefined,
      type: "cost_breakdown",
      date_granularity: setup.frequency,
      chart_type: setup.viewType,
      layout: null,
      forecast_option: setup.forecastOption,
      dates: setup.dates,
    };

    try {
      const response = await dispatch(
        buildWidgetThunk({
          widgetId: setup?.id,
          widget,
        }),
      ).unwrap();

      if (response && setup?.id) {
        await dispatch(
          getCostBreakdownV2WidgetDataByWidgetIdThunk(response.id),
        );
      }
      return response?.id;
    } catch (e) {
      // @ts-expect-error todo: api fix
      const errMessage = e?.data?.message || "Something went wrong";
      enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "error" },
      });

      return null;
    }
  },
);
